import { Plan } from "./plan";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { PayHeader } from "../Paymentheader/PayHeader";
import { EditOutlined } from "@ant-design/icons";
import { Modal } from "antd/lib";
import { insuranceproduct } from "../../Redux/actions/NumCaration";
import CarPrevpolictype from "./CarPrevPolicyType";
import CarOwmeredit from "./CarOwnerEdit";
import CarPrevpolexp from "./CarPrevPolicy";
import CarRegdateupdate from "./CarRegDateUpdate";
import CarEdit from "./CarEdit";

function PlanLayout2() {
  const QuickQuotes = useSelector((state) => state?.cardetail?.quickquotes);
  const QuickQuotePost = useSelector(
    (state) => state?.cardetail?.quickQuotePost
  );
  const QuoteInput = useSelector((state) => state?.cardetail?.quoteInput);
  const bikeMakedata = useSelector((state) => state?.cardetail?.carMakeData);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOwner, setisModalOwner] = useState(false);
  const [isModalExp, setisModalExp] = useState(false);
  const [isModalReg, setisModalReg] = useState(false);
  const [isModalBike, setisModalBike] = useState(false);
  const [product, setproduct] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const [scrolled, setScrolled] = useState(false);
  const [fuelType, setFuelType] = useState("");
  const temp = useSelector((state) => state.addressdetail.data);
  // const { previousNoClaimBonus } = QuickQuotes?.previousInsurer;
  // const { currentNoClaimBonus } = QuickQuotes?.contract;
  // console.log("Vehicle Details Layout", QuickQuotes);

  const handleScroll = () => {
    if (window.scrollY > 80) {
      setScrolled(true);
      // console.log(scrolled);
    } else {
      setScrolled(false);
      // console.log(scrolled);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    getData();
    // console.log(history.location.state);
    dispatch(insuranceproduct())
      .then((res) => {
        setproduct(res);
      })
      .catch((err) => {
        console.log(err.response);
        if (err?.response?.data?.message === "Unauthenticated.") {
          dispatch((dispatch) => {
            dispatch({ type: "RESET_CAR" });
          });
          history.push("/");
        }
      });
  }, [dispatch]);

  useEffect(() => {
    const inputString = bikeMakedata?.customized_variant;
    const match = inputString?.match(/\(([^)]+)\)$/);
    if (match) {
      const result = match[1];
      // console.log(result);
      if (result === "P") {
        setFuelType("PETROL");
      } else if (result === "D") {
        setFuelType("DIESEL");
      } else if (result === "E") {
        setFuelType("ELECTRIC");
      } else if (result === "BATTERY") {
        setFuelType("BATTERY");
      }
    } else {
      console.log("No match found.");
    }
  }, [bikeMakedata]);

  const getData = async () => {
    if (temp) {
      setLoading(true);
    }
  };
  // console.log("after dispatch", temp);
  const policyTypeClick = () => {
    setIsModalOpen(true);
  };
  const ownerType = () => {
    setisModalOwner(true);
  };
  const HandleExp = () => {
    setisModalExp(true);
  };
  const HandleReg = () => {
    setisModalReg(true);
  };
  const HandleBike = () => {
    setisModalBike(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleCancelOwn = () => {
    setisModalOwner(false);
  };
  const handleCancelExp = () => {
    setisModalExp(false);
  };
  const handleCancelReg = () => {
    setisModalReg(false);
  };
  const handleCancelBike = () => {
    setisModalBike(false);
  };

  //  console.log('QuickQuotePost product',QuickQuotePost)

  return loading ? (
    <div>
      <PayHeader />
      <div className={scrolled ? `sticky` : `editquote`}>
        <div className="row justify-content-center">
          <div className="col-xl-2 col-lg-12 col-md-12 col-sm-12 edit-layout">
            <div className="editbike">
              <div className="editvalueq">
                {QuickQuotePost?.make} {QuickQuotePost?.model}
              </div>
            </div>
            <div className="editbike">
              CAR | {fuelType} |{" "}
              <div className="editvalueq">
                {QuickQuotePost?.licensePlateNumber}
              </div>
              <EditOutlined
                key="save"
                style={{ cursor: "pointer" }}
                onClick={HandleBike}
              />
            </div>
          </div>
          <div className="col-xl-3 col-lg-12 col-md-12 col-sm-12 edit-layout">
            <div className="editbike">
              PREVIOUS POLICY TYPE:{" "}
              {QuoteInput?.insuranceProductCode === "PVP" ? (
                <div className="editvalueq">COMPREHENSIVE</div>
              ) : QuoteInput?.insuranceProductCode === "PVT" ? (
                <div className="editvalueq">THIRD-PARTY</div>
              ) : QuoteInput?.insuranceProductCode === "PVS" ? (
                <div className="editvalueq">2W SAOD only</div>
              ) : QuoteInput?.insuranceProductCode === "Bundled" ? (
                <div className="editvalueq">BUNDLED</div>
              ) : QuoteInput?.insuranceProductCode === "Not_Secure" ? (
                <div className="editvalueq">NOT SECURE</div>
              ) : (
                ""
              )}
              <EditOutlined
                key="save"
                style={{ cursor: "pointer" }}
                onClick={policyTypeClick}
              />
            </div>
            <div className="editbike">
              OWNERSHIP:{" "}
              <div className="editvalueq">
                {QuickQuotePost?.policyHolderType}
              </div>
              <EditOutlined
                key="save"
                style={{ cursor: "pointer" }}
                onClick={ownerType}
              />
            </div>
          </div>
          <div className="col-xl-3 col-lg-12 col-md-12 col-sm-12 edit-layout">
            <div className="editbike">
              PREVIOUS POLICY EXPIRY:{" "}
              <div className="editvalueq">
                {QuickQuotePost?.previousPolicyExpiryDate}
              </div>
              <EditOutlined
                key="save"
                style={{ cursor: "pointer" }}
                onClick={HandleExp}
              />
            </div>
            <div className="editbike">
              REGISTERED ON:{" "}
              <div className="editvalueq">
                {QuickQuotePost?.registrationDate}
              </div>
              <EditOutlined
                key="save"
                style={{ cursor: "pointer" }}
                onClick={HandleReg}
              />
            </div>
          </div>
          <div className="col-xl-2 col-lg-12 col-md-12 col-sm-12 edit-layout">
            <div className="editbike">
              Previous NCB :{" "}
              <div className="editvalueq">
                {QuoteInput?.ncbvalue === 0
                  ? "0%"
                  : QuoteInput?.ncbvalue === 20
                  ? "20%"
                  : QuoteInput?.ncbvalue === 25
                  ? "25%"
                  : QuoteInput?.ncbvalue === 35
                  ? "35%"
                  : QuoteInput?.ncbvalue === 45
                  ? "45%"
                  : QuoteInput?.ncbvalue === 50
                  ? "50%"
                  : QuoteInput?.productCode === "PVT"
                  ? "N/A"
                  : ""}
              </div>
              {/* <EditOutlined key="save" style={{cursor: "pointer"}} onClick={HandleExp}/> */}
            </div>
            <div className="editbike">
              Current Applicable NCB :{" "}
              <div className="editvalueq">
                {QuoteInput?.ncbvalue === 0
                  ? "20%"
                  : QuoteInput?.ncbvalue === 20
                  ? "25%"
                  : QuoteInput?.ncbvalue === 25
                  ? "30%"
                  : QuoteInput?.ncbvalue === 35
                  ? "45%"
                  : QuoteInput?.ncbvalue === 45
                  ? "50%"
                  : QuoteInput?.ncbvalue === 50
                  ? "50%"
                  : QuoteInput?.productCode === "PVT"
                  ? "0%"
                  : ""}
              </div>
              {/* <EditOutlined key="save" style={{cursor: "pointer"}} onClick={HandleReg}/> */}
            </div>
          </div>
        </div>
      </div>

      <Plan />
      <p className="exclusive" variant="h9">
        *Validity of the Quotation is till the end of the day on which the quote
        is generated
      </p>

      <Modal
        title="What type of policy did you buy last year?"
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        maskClosable={false}
      >
        <CarPrevpolictype setIsModalOpen={setIsModalOpen} />
      </Modal>
      <Modal
        title="Choose the Journey Type"
        open={isModalOwner}
        footer={null}
        onCancel={handleCancelOwn}
        maskClosable={false}
      >
        <CarOwmeredit setisModalOwner={setisModalOwner} />
      </Modal>
      <Modal
        title="Select Previous Policy Expiration Date"
        open={isModalExp}
        footer={null}
        onCancel={handleCancelExp}
        maskClosable={false}
      >
        <CarPrevpolexp setisModalExp={setisModalExp} />
      </Modal>
      <Modal
        title="Registration Year"
        open={isModalReg}
        footer={null}
        onCancel={handleCancelReg}
        maskClosable={false}
      >
        <CarRegdateupdate setisModalReg={setisModalReg} />
      </Modal>
      <Modal
        title="Vehicle Details"
        open={isModalBike}
        footer={null}
        onCancel={handleCancelBike}
        maskClosable={false}
      >
        <CarEdit setisModalBike={setisModalBike} />
      </Modal>
    </div>
  ) : (
    <div></div>
  );
}

export { PlanLayout2 };
